<template>
  <div>
    <Navbar :loginActive="false" :showLogout="false" />

    <section class="section">
        <div class="container is-fluid">
            <div class="columns">
                <div class="column is-3">
                </div>

                <div class="column is-6">
                    <h3 class="title">{{ $t("login.title") }}</h3>

                    <div class="field">
                        <label class="label">{{ $t("misc.email") }}</label>
                        <div class="control">
                            <input class="input" v-model="email" type="text">
                        </div>
                    </div>

                    <div v-if="!passwordResetActive">
                        <div class="field">
                            <label class="label">{{ $t("misc.password") }}</label>
                            <div class="control">
                                <input class="input" v-model="password" type="password">
                            </div>
                        </div>

                        <p>
                            {{ $t("login.forgottenPassword") }}
                            <a @click="passwordResetActive = true">{{ $t("misc.clickHere") }}</a>
                        </p>

                        <br/>

                        <vue-recaptcha
                            :sitekey="recaptchaSiteKey"
                            @verify="recaptchaVerified">
                        </vue-recaptcha>

                        <br/>

                        <b-button
                            type="is-primary"
                            @click="login(email, password, view, recaptchaToken)">
                            {{ $t("misc.login") }}
                        </b-button>
                    </div>

                    <div v-if="passwordResetActive">
                        <p>
                            <a @click="passwordResetActive = false">{{ $t("login.backToLogin") }}</a>
                        </p>

                        <br/>

                        <b-button
                            type="is-primary"
                            @click="sendPasswordReset">
                            {{ $t("login.passwordResetButtonText") }}
                        </b-button>
                    </div>
                </div>
                <div class="column is-3">
                </div>
            </div>
        </div>
    </section>
  </div>
</template>

<script>

import shared from '@/utils.js';

import VueRecaptcha from 'vue-recaptcha';
import Navbar from "@/components/Navbar.vue";


export default {
  name: "Login",
  components: {
    Navbar,
    VueRecaptcha
  },
  data: function () {
    return {
        email: "",
        password: "",
        view: null,
        passwordResetActive: false,
        recaptchaToken: null,
        recaptchaSiteKey: process.env.VUE_APP_RECAPTCHA_SITE_KEY
    }
  },
  methods: {
    sendPasswordReset: function () {
        let view = this;

        shared.getApi().post(`send-reset-password/${this.email}`).then(function (response) {
            if (response.status == 200) {
                view.$buefy.toast.open({
                    message: view.$t("login.passwordResetEmailSent"),
                    type: "is-success"
                })
            } else {
                view.$buefy.toast.open({
                    message: view.$t("login.genericError"),
                    type: "is-danger"
                })
            }
        }).catch(function () {
            view.$buefy.toast.open({
                message: view.$t("login.genericError"),
                type: "is-danger"
            })
        });
    },
    recaptchaVerified: function (response) {
        this.recaptchaToken = response;
    }
  },
  mounted: function () {
    this.login = shared.login;
    this.view = this;

    if (window.localStorage.backendToken != null) {
        // The user is already logged in
        this.$router.push("/");
    }
  }
}

</script>